
export function getTeethLabelsBySide(isUpper) {
    const upperLabels = ["18", "17", "16", "15", "14", "13", "12", "11", "28", "27", "26", "25", "24", "23", "22", "21"]
    const lowerLabels = ["48", "47", "46", "45", "44", "43", "42", "41", "38", "37", "36", "35", "34", "33", "32", "31"]

    return isUpper ? upperLabels : lowerLabels
}

export function mergeTeethDataBySide(existingData = [], updatedData = [], isUpper = true) {
    if(!Array.isArray(existingData) || !existingData.length){
        return Array.isArray(updatedData) ? [...updatedData] : []
    }

    const labels = new Set(getTeethLabelsBySide(isUpper).map(label => String(label)))
    const merged = [...existingData]
    const updatedByLabel = new Map(
        (Array.isArray(updatedData) ? updatedData : []).map(item => [String(item.label), item])
    )

    for(let i = 0; i < merged.length; i++){
        const label = String(merged[i].label)
        if(labels.has(label) && updatedByLabel.has(label)){
            merged[i] = updatedByLabel.get(label)
        }
    }

    return merged
}

function teeth2string(teeth){
    return JSON.stringify(teeth.map(t => {
        return {
            label:t.label,
            state:t.state,
        }
    }))
}



function hexToBooleanArray(hex) {
    hex = hex.replace(/^0x/i, '');

  const bits = [...hex].flatMap(char => {
    const value = parseInt(char, 16);

    if (Number.isNaN(value)) {
      throw new Error(`Invalid hex character: ${char}`);
    }

    return [8, 4, 2, 1].map(mask => (value & mask) !== 0);
  });

  return Array(Math.max(0, 16 - bits.length))
    .fill(false)
    .concat(bits);
}

function mirror(val,plane){
    return plane - val + plane
}

function scale(obj,scale){
    obj.x *= scale
    obj.y *= scale
}


window.teethComponentLoaded = async function(ref,isUpper,disabled,inAdmin){

    let teeth = [
        {label:"18",x:7,y:87,state:0,isRound:false,},
        {label:"17",x:9,y:74,state:0,isRound:false,},
        {label:"16",x:12,y:61,state:0,isRound:false,},
        {label:"15",x:17,y:48,state:0,isRound:false,},
        {label:"14",x:23,y:35,state:0,isRound:false,},
        {label:"13",x:31,y:23,state:0,isRound:false,},
        {label:"12",x:42,y:15,state:0,isRound:true,},
        {label:"11",x:54,y:11,state:0,isRound:true,},

        {label:"28",x:420,y:290,state:0,isRound:false,},
        {label:"27",x:410,y:250,state:0,isRound:false,},
        {label:"26",x:395,y:210,state:0,isRound:false,},
        {label:"25",x:375,y:170,state:0,isRound:false,},
        {label:"24",x:355,y:130,state:0,isRound:false,},
        {label:"23",x:320,y:90,state:0,isRound:false,},
        {label:"22",x:275,y:80,state:0,isRound:true,},
        {label:"21",x:230,y:75,state:0,isRound:true,},

        //lowerteeth
        {label:"48",x:0,y:290,state:0,isRound:false,},
        {label:"47",x:10,y:250,state:0,isRound:false,},
        {label:"46",x:25,y:210,state:0,isRound:false,},
        {label:"45",x:45,y:170,state:0,isRound:false,},
        {label:"44",x:65,y:130,state:0,isRound:false,},
        {label:"43",x:100,y:90,state:0,isRound:false,},
        {label:"42",x:145,y:80,state:0,isRound:true,},
        {label:"41",x:190,y:75,state:0,isRound:true,},

        {label:"38",x:420,y:290,state:0,isRound:false,},
        {label:"37",x:410,y:250,state:0,isRound:false,},
        {label:"36",x:395,y:210,state:0,isRound:false,},
        {label:"35",x:375,y:170,state:0,isRound:false,},
        {label:"34",x:355,y:130,state:0,isRound:false,},
        {label:"33",x:320,y:90,state:0,isRound:false,},
        {label:"32",x:275,y:80,state:0,isRound:true,},
        {label:"31",x:230,y:75,state:0,isRound:true,},
    ]

    for(var i = 0; i < 8; i++){
        teeth[i + 8].x = mirror(teeth[i].x,60)
        teeth[i + 8].y = teeth[i].y
    }

    for(var i = 0; i < 16; i++){
        teeth[i + 16].x = teeth[i].x
        teeth[i + 16].y = mirror(teeth[i].y,50)
    }

    for(var i = 0; i < 32; i++){
        scale(teeth[i],2.5)
    }


    // partieel immediaat
    // partieel frame immediaat
    // flexible partieel immediaaat
    // 18,28,48,38 starten als kruisje

    // return
    
    //orderteeth only gets made after going to next page
    //needs to be premade

    //check if orderteeth exists, create if needed
    await sleep(1000)//wait for activeproductorder to be set
    var orderteeth = (await window.getPaulAsync('orderTeeth','productOrderId',window.activeproductorder.id))[0]
    if(orderteeth == null){
        await window.createPaulAsync('orderTeeth',{
            productOrderId:window.activeproductorder.id,
            manufacturerTypeId:2,
            frontCharacterizationTypeId:2,
            incisalRelationshipTypeId:2,
        })
        orderteeth = (await window.getPaulAsync('orderTeeth','productOrderId',window.activeproductorder.id))[0]
    }
    var allprodtypes = await window.getPaulAsync('productType','',0)

    var upperoptions = 2
    var loweroptions = 2
    var upperprodtype = allprodtypes.find(pt => pt.id == window.activeproductorder.upperProductId)
    var lowerrodtype = allprodtypes.find(pt => pt.id == window.activeproductorder.lowerProductId)

    //check of immediaat of niet
    // bij niet immediaat
    // 1 te behouden element
    // 2 stippelbox met kruis


    // bij immediaat
    // 1 te behouden element
    // 2 stippelbox
    // 3 solid met kruis

    var threeoptionlegend = [
        {
            text:"Te behouden element",
            boxIsDotted:false,
            cross:false,
        },{
            text:"Extraheren en opstellen",
            boxIsDotted:true,
            cross:false,
        },{
            text:"Extraheren, niet opstellen",
            boxIsDotted:true,
            cross:true,
        },
    ]

    var twooptionlegend = [
        {
            text:"Extraheren en opstellen",
            boxIsDotted:true,
            cross:false,
        },{
            text:"Niet op te stellen",
            boxIsDotted:true,
            cross:true,
        },
    ]

    var legend = threeoptionlegend



    if(upperprodtype?.nl.includes('Volledige immediaat prothese') || upperprodtype?.nl.includes('noodprothese')){
        if(isUpper){
            legend = twooptionlegend
            // isImmediaat = true
        }
    }
    if(lowerrodtype?.nl.includes('Volledige immediaat prothese') || lowerrodtype?.nl.includes('noodprothese')){
        if(isUpper == false){
            legend = twooptionlegend
            // isImmediaat = true
        }
    }

    orderteeth.upperHex
    orderteeth.lowerHex
    if(orderteeth.upperHex == null && orderteeth.lowerHex == null && orderteeth.teethdata == null){
        //only do t
        if(isUpper){
            teeth[0].state = legend.length -1
            teeth[8].state = legend.length -1
        }else{
            teeth[16].state = legend.length -1
            teeth[24].state = legend.length -1
        }
    }else if(orderteeth.teethdata){
        var data = JSON.parse(orderteeth.teethdata)
        for(var item of data){
            var tooth = teeth.find(t => t.label == item.label)
            tooth.state = item.state
        }
    }else{
        var offset = 0
        var boolarr = []
        if(isUpper){
            boolarr = hexToBooleanArray(orderteeth.upperHex).reverse()
        }else{
            offset = 16
            boolarr = hexToBooleanArray(orderteeth.lowerHex)
        }
        for (let i = 0; i < boolarr.length; i++) {
            teeth[i + offset].state = boolarr[i] == true ? 1 : 0
        }
    }


    //todo,
    //load current data into teethcomponent
    //save into 
    startContext(ref)
        crns('svg',{viewBox:"0 0 350 400",width:"100%",style:"max-width:400px;" })
            let size = 30


            // DRAWING LEGEND
            if(inAdmin == false){
                crns('g',{transform:"translate(10,250)"});
                let y = 10
                for(var item of legend){
                    crns('rect',{x:1,y:y,width:size,height:size,rx:10,ry:10,style:`${item.boxIsDotted ? "stroke-dasharray:2;" : ""}fill:white;stroke:black;stroke-width:1;`});end();
                    crns('text',{x:35,y:y + 15,"font-weight":"500","font-size":"15px","dominant-baseline":"middle"});text(item.text);end();
                    if(item.cross){
                        crns('line',{stroke:'black',x1:1,y1:y,x2:1 + size,y2:y + size});end();
                        crns('line',{stroke:'black',x1:1,y1:y + size,x2:1 + size,y2:y});end();
                    }
                    y += 40
                }
                end()
            }


            // DRAWING TEETH
            crns('text',{x:165,y:120,"font-weight":"500","font-size":"30px","text-anchor":"middle","dominant-baseline":"middle"});text(isUpper ? "Boven" : "Onder");end();
            for(let i = 0; i < 16; i++){
                var offset = isUpper ? 0 : 16
                let location = teeth[i + offset]
                let group = crns('g');
                let teethelem = null
                if(location.isRound){
                    teethelem = crns('circle',{cx:location.x + size/2,cy:location.y + size/2,r:size / 2,style:"fill:white;stroke:black;stroke-width:1;"});end();
                }else{
                    teethelem = crns('rect',{x:location.x,y:location.y,width:size,height:size,rx:10,ry:10,style:"fill:white;stroke:black;stroke-width:1;"});end();
                }

                let crosselem1 = crns('line',{stroke:'black',x1:location.x,y1:location.y,x2:location.x + size,y2:location.y + size});end();
                let crosselem2 = crns('line',{stroke:'black',x1:location.x,y1:location.y + size,x2:location.x + size,y2:location.y});end();
                crns('text',{x:location.x + size / 2,y:location.y + size / 2,"text-anchor":"middle","dominant-baseline":"middle"});text(location.label);end();
                end();
                function setprops(){
                    // someething here
                    // also check if immediaat or not

                    if(legend.length == 3){
                        if(location.state == 0){
                            crosselem1.setAttribute('opacity',0)
                            crosselem2.setAttribute('opacity',0)
                            teethelem.setAttribute('stroke-dasharray','none')
                        }else if(location.state == 1){
                            crosselem1.setAttribute('opacity',0)
                            crosselem2.setAttribute('opacity',0)
                            teethelem.setAttribute('stroke-dasharray','2')
                        }else if(location.state == 2){
                            crosselem1.setAttribute('opacity',1)
                            crosselem2.setAttribute('opacity',1)
                            teethelem.setAttribute('stroke-dasharray','2')
                        }
                    }else if(legend.length ==2){
                        if(location.state == 0){
                            crosselem1.setAttribute('opacity',0)
                            crosselem2.setAttribute('opacity',0)
                            teethelem.setAttribute('stroke-dasharray','2')
                        }else if(location.state == 1){
                            crosselem1.setAttribute('opacity',1)
                            crosselem2.setAttribute('opacity',1)
                            teethelem.setAttribute('stroke-dasharray','2')
                        }
                    }

                }
                setprops()
                group.addEventListener('click',async () => {
                    if(disabled){
                        return
                    }
                    location.state += 1;
                    location.state %= legend.length
                    setprops()

                    //also update upper/lower hex?
                    var data = teeth.map(tooth => {
                        return {
                            label:tooth.label,
                            state:tooth.state
                        }
                    })
                    



                    let recentdata = []
                    const storedData = (await window.getPaulAsync('orderTeeth','id', orderteeth.id))[0]?.teethdata
                    if(storedData){
                        recentdata = JSON.parse(storedData)
                    }

                    const mergedData = mergeTeethDataBySide(recentdata, data, isUpper)
                    await update('orderTeeth',{id:orderteeth.id,teethdata:mergedData})

                });
                
            }
        end()
        if(inAdmin == false){
            crend('div','Selecteer de te extraheren elementen',{})
        }
    endContext()
}




























function crns(tag,attributes = {}){
    var parent = peek()
    var element = document.createElementNS("http://www.w3.org/2000/svg",tag)
    if(parent){
        parent.appendChild(element)
    }
    for(var key in attributes){
        element.setAttribute(key,attributes[key])
    }
    currentContext().push(element)
    return element
}



function getQueryParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}


var contextStack = [[document.body]]

function currentContext(){
    return last(contextStack)
}

function last(arr){
    return arr[arr.length - 1]
}

function startContext(element){
    contextStack.push([element])
}

function endContext(){
    contextStack.pop()
}


function scr(tag,attributes = {}){
    flush()
    return cr(tag,attributes)
}

function cr(tag,attributes = {}){
    var parent = peek()
    var element = document.createElement(tag)
    if(parent){
        parent.appendChild(element)
    }
    for(var key in attributes){
        element.setAttribute(key,attributes[key])
    }
    currentContext().push(element)
    return element
}

function crend(tag,textstring,attributes = {}){
    cr(tag,attributes)
    text(textstring)
    return end()
}

function text(data){
    peek().textContent = data
    return peek()
}

function html(html){
    peek().innerHTML = html
}

function end(endelement = null){
    var poppedelement = currentContext().pop()
    if(endelement != null && endelement != poppedelement){
        console.warn(poppedelement,' doesnt equal ', endelement)
    }
    return poppedelement
}

HTMLElement.prototype.on = function(event,cb){
    this.addEventListener(event,cb)
    return this
}

function peek(){
    var context = currentContext()
    return last(context)
}

function flush(){
    var context = currentContext()
    var root = context[0]
    context.length = 0
    return root
}

function div(options = {}){
    return cr('div',options)
}

function a(options = {}){
    return cr('a',options)
}

function button(text,options = {}){
    return crend('button',text,options)
}

function input(options = {}){
    return crend('input',options)
}

function img(options = {}){
    return crend('img',options)
}


function stringToHTML (str) {
	var temp = document.createElement('template');
    
    temp.innerHTML = str;
    return temp.content.firstChild;
}

function upsertChild(parent,child){
    if(parent.firstChild){
        parent.replaceChild(child,parent.firstChild)
    }else{
        parent.appendChild(child)
    }
}

function qs(element,query){
    if(typeof element == 'string'){
        return document.body.querySelector(element)    
    }
    return element.querySelector(query)
}

function qsa(element,query){
    return Array.from(element.querySelectorAll(query))
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}